module.exports = __webpack_public_path__ + "img/about_new.d0101321.jpg";